var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import GoodService from "../../api/GoodService";
import { Loading } from 'element-ui';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.categoryData = [];
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = GoodService.getInstance();
        this.getCategory();
    };
    Dialog.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Dialog.prototype.getCategory = function () {
        var _this = this;
        this.service.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.submitData = function () {
        var _this = this;
        if (!this.goodId) {
            this.$message.error('请选择货品分类');
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.setCategory({
            goods_ids: this.goodId,
            goods_type_id: this.category
        }).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            _this.$emit('transferCategory');
            _this.close();
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    Dialog.prototype.treeOpen = function () {
        this.$refs.treeSelect.$refs.portal.portalTarget.setupHandlers();
    };
    Dialog = __decorate([
        Component
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
